import { useRef } from 'react';

import { useIsClamped } from '@crm/shared/lib/react';

export const DealCardDescription = ({ description }: { description?: string | null }) => {
    const textRef = useRef<HTMLParagraphElement>(null);
    const isClamped = useIsClamped(textRef);
    const textContent = description ?? '';

    return (
        <div className="rounded-lg bg-slate-100 px-2 py-1.5">
            <p
                ref={textRef}
                className="text-smtr-main-tertiary-100 line-clamp-2 text-xs"
                title={isClamped ? textContent : undefined}
            >
                {textContent}
            </p>
        </div>
    );
};
